import dayjs from 'dayjs';
import { MRT_ColumnFilterFnsState } from 'material-react-table';
import { useEffect, useState } from 'react';

export const useTableServerSideFiltering = () => {
  // server side filters - colums table
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFilterFnsState>(
    [] as any
  );
  const [filterObject, setFilterObject] = useState<any>({});

  // map date in table filter by date - server sider filtering
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilterObject(
        (columnFilters as any)?.reduce((obj: any, item: any) => {
          obj[item.id] = item?.value;
          if (item.id.includes('fecha')) {
            obj[item.id] = dayjs(item?.value).format('YYYY-MM-DD');
          }

          return obj;
        }, {})
      );
    }, 1000); // 2000 ms = 2 segundos
    return () => clearTimeout(timer);
  }, [columnFilters]);

  return {
    columnFilters,
    setColumnFilters,
    filterObject,
    setFilterObject,
  };
};
